import { useQueueFlow } from './flowContext';
import type { QueueCandidate } from './model';

/**
 * Whether **this** card is the one currently asking what the press on it meant.
 *
 * A card needs the answer for two things at once — the two buttons over its picture, and standing
 * its corner controls down while they are there — so it is a question rather than a piece of state
 * the card keeps: the pressed card lives in the one flow the app mounts
 * (`QueueActionsHost.tsx`), which is what keeps two cards from ever asking together.
 *
 * Its own module rather than a second export from `QueueCardAsk.tsx`, for `flowContext.ts`'s reason:
 * a file exporting a component *and* a function costs Fast Refresh, so an edit to the overlay would
 * reload the whole app instead of swapping the component.
 *
 * `null` is a row with nothing to queue — a dead playlist entry, a history row whose video is gone —
 * and it answers the same as a card nobody pressed.
 */
export function useQueueCardAsk(item: QueueCandidate | null): boolean {
  const flow = useQueueFlow();
  return flow !== null && item !== null && flow.asking(item);
}
